import React from "react";
import { connect } from "react-redux";
import HeaderNavbar from "../SideBar/NavBar";
import logo from "../../assets/img/logo_sys.png";
import "./Header.css";

const HeaderComponent = ({ Username }) => {
  return (
    <header className="custom-header">

      <div className="header-left">

        <HeaderNavbar />

        <div className="logo-box">
          <img
            src={logo}
            alt="System Admin"
            className="header-logo"
          />
        </div>

        <div className="header-title">
          <h5>System Admin Console</h5>
          <small>IT Asset Management</small>
        </div>

      </div>

      <div className="header-right">

        <div className="user-box">

          <div className="user-avatar">
            {Username.charAt(0).toUpperCase()}
          </div>

          <div>

            <div className="welcome-text">
              Welcome
            </div>

            <div className="username">
              {Username}
            </div>

          </div>

        </div>

      </div>

    </header>
  );
};

const mapStateToProps = (state) => ({
  Username: state.profile.Username || ""
});

export default connect(mapStateToProps)(HeaderComponent);